import React, { useState, useCallback, useMemo } from 'react';

import OptionsList from './OptionsList';
import PlainButton from '../../common/PlainButton';
import FilterSearchInput from './FilterSearchInput';
import { FilterOption } from './FilterSelect';

import styles from './FilterMenu.scss';

interface FilterMenuProps {
  onChange: (event: unknown, value: string) => void;
  onApply: () => void;
  options: FilterOption[];
  selectedValues: string[];
  isApplyDisabled?: boolean;
  className?: string;
  isSearchable?: boolean;
}

function FilterMenu(props: FilterMenuProps): React.ReactElement {
  const { onChange, options, selectedValues, onApply, isApplyDisabled, className, isSearchable } = props;
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = useCallback((value: string) => {
    setSearchQuery(value);
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchQuery.trim()) {
      return options;
    }

    const lowerQuery = searchQuery.toLowerCase();
    return options.filter((option) => option.label.toLowerCase().includes(lowerQuery));
  }, [options, searchQuery]);

  return (
    <div className={`${styles.dropdown} ${className || ''}`}>
      {isSearchable && (
        <FilterSearchInput
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="CLAIMS_CENTER_FILTER_SEARCH_INPUT_PLACEHOLDER"
        />
      )}
      <OptionsList options={filteredOptions} selectedValues={selectedValues} onChange={onChange} />
      <PlainButton name="applyFilter" tabIndex={-1} disabled={isApplyDisabled} onClick={onApply}>
        Apply
      </PlainButton>
    </div>
  );
}

export default React.memo(FilterMenu);
